export default "__VITE_ASSET__e3rqEA3C__"